import * as THREE from 'three';
import type { WindField } from './WindField';

export interface WindSnapshot {
  readonly speedMph: number;
  readonly directionDegrees: number;
  readonly relativeToAimDegrees: number;
  readonly arrowDegrees: number;
}

export class GameplayWind implements WindField {
  constructor(
    private readonly baseVelocity = new THREE.Vector3(4.2, 0, -1.4),
    private readonly gustFraction = 0.08,
  ) {}

  sample(_position: THREE.Vector3, elapsedSeconds: number): THREE.Vector3 {
    const gust = 1 + Math.sin(elapsedSeconds * 0.37) * this.gustFraction;
    return this.baseVelocity.clone().multiplyScalar(gust);
  }

  snapshot(aimRadians: number, elapsedSeconds: number): WindSnapshot {
    const v = this.sample(new THREE.Vector3(), elapsedSeconds);
    const speedMph = v.length() * 2.236936;
    const directionRadians = Math.atan2(v.x, v.z);
    const relative = THREE.MathUtils.radToDeg(directionRadians - aimRadians);
    return {
      speedMph,
      directionDegrees: THREE.MathUtils.radToDeg(directionRadians),
      relativeToAimDegrees: relative,
      arrowDegrees: relative,
    };
  }
}
